import { split as _split } from 'lodash'

import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'

function getStringsArrayFromPlaceholders(key, numOfPlaceholders = 1) {
  const placeholderPattern = '%1$s'
  const placeholders = []

  for (let i = 0; i < numOfPlaceholders; i++) {
    placeholders.push(placeholderPattern)
  }

  const translatedKey = ContentManager.translate(key, placeholders, {
    placeHolderRegEx: /%[1-9][0-9]*\$s/g,
  })

  return _split(translatedKey, placeholderPattern)
}

export { getStringsArrayFromPlaceholders } // eslint-disable-line import/prefer-default-export
